<template lang="pug">
.carousel
  .carousel-main
    button.carousel-arrow.left(@click="prevImage") &lt;
    .carousel-item(v-for="(image, index) in images" :key="index" :class="{ active: index === currentIndex }")
      img(:src="image.href" :alt="image.description")
    button.carousel-arrow.right(@click="nextImage") &gt;
  .carousel-thumbnails-wrapper
    button.thumbnail-arrow.left(@click="scrollThumbnails(-1)") &lt;
    .carousel-thumbnails
      .thumbnails-container
        .thumbnail-item(
          v-for="(image, index) in images.slice(thumbnailIndex, thumbnailIndex + visibleThumbnails)"
          :key="index"
          :class="{ active: index + thumbnailIndex === currentIndex }"
          @click="selectMainImage(index + thumbnailIndex)"
          class=""
        )
          img(:src="image.href" :alt="image.description" class="tw-rounded-md")
    button.thumbnail-arrow.right(@click="scrollThumbnails(1)") &gt;
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
      thumbnailIndex: 0,
      visibleThumbnails: 4,
    };
  },
  methods: {
    selectMainImage(index) {
      this.currentIndex = index;
      this.updateThumbnailIndex();
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.updateThumbnailIndex();
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.updateThumbnailIndex();
    },
    updateThumbnailIndex() {
      const minIndex = this.thumbnailIndex;
      const maxIndex = this.thumbnailIndex + this.visibleThumbnails - 1;
      if (this.currentIndex < minIndex) {
        this.thumbnailIndex = this.currentIndex;
      } else if (this.currentIndex > maxIndex) {
        this.thumbnailIndex = this.currentIndex - this.visibleThumbnails + 1;
      }
    },
    scrollThumbnails(direction) {
      const newIndex = this.thumbnailIndex + direction;
      if (newIndex >= 0 && newIndex <= this.images.length - this.visibleThumbnails) {
        this.thumbnailIndex = newIndex;
      }
    },
  },
  computed: {
    displayedThumbnails() {
      return this.images.slice(this.thumbnailIndex, this.thumbnailIndex + this.visibleThumbnails);
    },
  },
};
</script>

<style scoped>
.carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-main {
  position: relative;
  width: 95%;
  height: auto;
}

.carousel-item {
  display: none;
}

.carousel-item.active {
  display: block;
}

.carousel-item img {
  width: 100%;
  height: auto;
  border-radius: 16px;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: rgb(178, 178, 178);
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1;
  border-radius: 100px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 22px;
  font-weight: bold;
}

.carousel-arrow.left {
  left: 0;
  margin-left: 5px;
}

.carousel-arrow.right {
  right: 0;
  margin-right: 5px;
}

.carousel-thumbnails-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 95%;
}

.carousel-thumbnails {
  overflow: hidden;
  display: flex;
  justify-content: center;
  width: calc(150px * 6 + 10px * 5); /* 6 thumbnails and 5 gaps */
}

.thumbnails-container {
  display: flex;
  transition: transform 0.3s ease;
}

.thumbnail-item {
  margin: 0 5px;
  cursor: pointer;
}

.thumbnail-item.active {
  border: solid #e7c873 3px;
  border-radius: 14px;
}

.thumbnail-item img {
  width: 180px;
  border-radius: 12px;
  height: auto;
}

.thumbnail-arrow {
  /* background: rgba(0, 0, 0, 0.5); */
  color: #e7c873;
  border: 3px solid #e7c873;
  border-radius: 50px;
  padding: 10px;
  font-size: 19px;
  font-weight: 800;
  padding-left: 13px;
  padding-right: 13px;
  cursor: pointer;
}
.thumbnail-arrow.left {
  left: 0;
  margin-left: 10px;
}
.thumbnail-arrow.right {
  right: 0;
  margin-right: 10px;
}
</style>
